import { useMutation } from 'react-query';
import { chatService, removeCache } from '../../../services';
import { enqueueSnackbar } from '../../../design-system';
import { i18n } from '../../../i18n';

type SendMessageProps = {
  id: string;
  content: string;
};

export const useSendMessageMutation = () => {
  return useMutation(
    ({ id, content }: SendMessageProps) => {
      return chatService.createMessage({ id, content });
    },
    {
      onSuccess: () => {
        removeCache(['chat']);
      },
      onError: () => {
        enqueueSnackbar(i18n.t('messages.network.error'), 'error');
      },
    },
  );
};
